import { FieldValues, Path, UseFormRegister } from "react-hook-form"

type TextInputProps<T extends FieldValues> = {
  register: UseFormRegister<T>
  error?: string
  label: string
  name: Path<T>
  placeholder: string
  disabled?: boolean
}

export const TextInput = <T extends FieldValues>({
  label,
  register,
  error,
  name,
  disabled,
  placeholder,
}: TextInputProps<T>) => {
  return (
    <>
      <div className="mt-6">
        <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
        <div className="mt-2">
          <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600 sm:max-w-md">
            <input
              {...register(name)}
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder={placeholder}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
      {error && <p className="mt-2 text-xs italic text-red-500">{error}</p>}
    </>
  )
}
